var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"giveaway-graph-container",attrs:{"wxid":_vm.$options.name}},[_c('figure',[(_vm.giveawayGraph && _vm.giveawayGraph.products.length > 0)?_c('wx-chart-line-graph',{attrs:{"css-classes":"canvas-container","chart-data":_vm.giveawayChartData,"chart-options":_vm.giveawayChartOptions}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }